module.exports = __webpack_public_path__ + "img/startCircle.7c59889a.svg";